import React, { Fragment, useState, useContext, useEffect } from "react";
import { DefaultPaddedContainer } from "../../styles/Theme";
import _ from "underscore";
import Sample from "./Sample";
import Link from "../Link";
import Button from "../Button";
import styled from "styled-components";
// import { Provider as SelectedTestsProvider } from "./contexts/SelectedTestsContext";
import TestResultsContext, { resultReducer } from "./contexts/SelectedTestsContext";
import SelectedTestsContext, { useSelectedTests } from "./contexts/SelectedTestsContext";
import { useTestResultsContext } from "./contexts/TestResultsContext";
import { post } from "../../lib/Fetching";
import Qualifier from "./inputs/Qualifier";
import CaveatPicker from "./CaveatPicker";
import CaveatCopier from "./CaveatCopier";
import SampleActionBar from "../sample_reporting/SampleActionBar";

const Table = styled.table`
  font-size: 9pt !important;
  background-color: white;
  td {
    padding: 0px !important;
    padding-left: 3px !important;
  }

  thead {
    tr {
      th {
        text-align: center;
        padding-left: 4px;
        padding-right: 4px;
      }
    }
  }
`;

export default function Samples({
  samples,
  reloadData,
  clientView = true,
  viewSingleSample,
  simpleSampleView,
  toggleSimpleSampleView,
}) {
  const [showHoldButtons, setShowHoldButtons] = useState(false);
  const [collapseEmpty, setCollapseEmpty] = useState(true);
  const [reason, setReason] = useState("");
  const [qualifier, setQualifier] = useState(1);
  const [showResultCaveatList, setShowResultCaveatList] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const {
    selectedTests,
    selectedSampleTestIds,
    clear,
    resetSelected,
    toggleForSample,
    selectedTestCount,
    unselectAllSamples,
  } = useSelectedTests();
  const { selectedResultCaveatIds, selectedSampleIds } = selectedTests;
  const {
    state,
    reset,
    addingResults,
    startAddingResults,
    stopAddingResults,
    setAllQualifiers,
  } = useTestResultsContext();

  const { dispatch } = useContext(SelectedTestsContext);

  const totalNumberOfTests =
    samples.map((s) => s.sample_tests.length).reduce((a, b) => a + b, 0) || 0;

  const checked =
    selectedTestCount >=
    samples.map((s) => s.sample_tests.length).reduce((a, b) => a + b, 0) / 2;

  useEffect(
    () => {
      // Clear selected tests when samples change
      resetSelected();
    },
    [samples]
  );

  function handleSelectSamples(e) {
    samples.map((sample) => {
      dispatch({
        type: "selectSample",
        selected: e.target.checked,
        sampleId: sample.sample.identifier,
      });
    });
  }

  const handleChecked = () =>
    checked
      ? clear()
      : samples.map((s) =>
          toggleForSample({
            select: true,
            sampleId: s.sample.identifier,
            sampleTestIds: s.sample_tests.map((st) => st.id),
          })
        );

  // returns { sampleId: [sampleTestId, sampleTestId,...], sampleId: [...]}
  const samplesWithSelectedTests = () => {
    return _.groupBy(
      selectedSampleTestIds,
      (sampleTestId) =>
        samples.find((s) => s.sample_tests.map((st) => st.id).includes(sampleTestId)).sample
          .identifier
    );
  };

  const handleSubmitResults = () => {
    setSubmitting(true);
    post("/sample_testing/sample_tests/create", { sample_tests: state.results, reason })
      .then((json) => {
        if (json.errors) {
          alert(I18n.t("there_was_a_problem_saving_these_results"));
        } else {
          setReason("");
          reset();
          reloadData().then(resetSelected);
        }
        setSubmitting(false);
      })
      .catch((error) => {
        alert(error);
        setSubmitting(false);
        throw error;
      });
  };

  const handleAcceptResults = () => {
    post("/sample_testing/sample_tests/accept_results", {
      samples: samplesWithSelectedTests(),
      reason,
    })
      .then((json) => {
        if (json.errors) {
          alert(I18n.t("there_was_a_problem_accepting_these_results"));
        } else {
          if (json.result.notice) {
            alert(json.result.notice);
          }
          setReason("");
          reset();
          reloadData().then(resetSelected);
        }
      })
      .catch((error) => {
        alert(error);
      });
  };
  const toggleHoldButtons = () => {
    setShowHoldButtons(!showHoldButtons);
  };

  const handleHold = () => {
    if (!confirm(I18n.t("hold_confirm"))) {
      return;
    }

    post("/sample_testing/sample_tests/hold_results", {
      samples: samplesWithSelectedTests(),
    })
      .then((json) => {
        setReason("");
        reset();
        reloadData().then(resetSelected);
      })
      .catch((error) => {
        alert(error);
      });
  };

  const handleUnHold = () => {
    if (!confirm(I18n.t("un_hold_confirm"))) {
      return;
    }

    post("/sample_testing/sample_tests/unhold_results", {
      samples: samplesWithSelectedTests(),
    })
      .then((json) => {
        setReason("");
        reset();
        reloadData().then(resetSelected);
      })
      .catch((error) => {
        alert(error);
      });
  };

  const handleRejectResults = () => {
    post("/sample_testing/sample_tests/reject_results", {
      samples: samplesWithSelectedTests(),
      reason,
    })
      .then((json) => {
        if (json.errors) {
          alert(I18n.t("there_was_a_problem_rejecting_these_results"));
        } else {
          setReason("");
          reset();
          reloadData().then(resetSelected);
        }
      })
      .catch((error) => {
        alert(error);
      });
  };

  const handlePickResultCaveats = () => setShowResultCaveatList(!showResultCaveatList);
  const handleEditTests = () => startAddingResults(selectedSampleTestIds);
  const handleStopEditingTests = () => stopAddingResults(selectedSampleTestIds);
  const handleDeleteCaveats = () => {
    if (selectedResultCaveatIds.length == 0) {
      alert(I18n.t("no_caveats_were_selected"));
      return;
    }
    post(
      "/sample_testing/result_caveats/destroy",
      {
        result_caveat_ids: selectedResultCaveatIds,
      },
      "DELETE"
    ).then((json) => {
      reloadData();
      alert(I18n.t("caveats_were_deleted"));
    });
  };

  const toolbarComponent = () => (
    <tr>
      <th
        colSpan="18"
        style={{
          height: 130,
          backgroundColor: "rgb(251, 251, 251)",
          paddingRight: 20,
          textAlign: "left",
        }}
      >
        <span className="pull-left">
          <SampleActionBar
            sampleIds={selectedSampleIds}
            clientView={clientView}
            showEditSamples={false}
            reloadData={reloadData}
          />
          <CaveatCopier
            sampleIds={selectedSampleIds}
            resultCaveatIds={selectedResultCaveatIds}
            onCopy={reloadData}
          />
        </span>
        <span className="pull-right" style={{ textAlign: "right", width: "700px" }}>
          <div>
            {addingResults > 0 && (
              <Button
                tiny
                title={I18n.t("submit_results")}
                onClick={handleSubmitResults}
                disabled={submitting}
                primary
              />
            )}
            {selectedTestCount > 0 && (
              <Fragment>
                &nbsp;&nbsp;
                <Button tiny onClick={handleEditTests} title={I18n.t("add_results")} />
                &nbsp;&nbsp;
                <Button tiny title={I18n.t("stop_adding")} onClick={handleStopEditingTests} />
              </Fragment>
            )}
            {!addingResults &&
              selectedTestCount > 0 && (
                <Fragment>
                  &nbsp;&nbsp;
                  <Button
                    tiny
                    primary
                    title={I18n.t("accept_results")}
                    onClick={handleAcceptResults}
                  />
                  &nbsp; &nbsp;
                  <Button
                    tiny
                    deleting
                    title={I18n.t("reject_results")}
                    onClick={handleRejectResults}
                  />
                </Fragment>
              )}
          </div>
          {(addingResults || selectedTestCount) > 0 && (
            <input
              style={{ marginTop: 10 }}
              placeholder={I18n.t("enter_reason_for_change")}
              className="form-control input-sm"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
            />
          )}
          <div style={{ marginTop: 10 }}>
            {selectedResultCaveatIds.length > 0 && (
              <Button
                deleting
                tiny
                title={I18n.t("delete_caveats")}
                onClick={handleDeleteCaveats}
              />
            )}
            {selectedTestCount > 0 && (
              <Button tiny title={I18n.t("pick_caveats")} onClick={handlePickResultCaveats} />
            )}
            {!addingResults &&
              selectedTestCount > 0 &&
              (showHoldButtons ? (
                <Fragment>
                  &nbsp; &nbsp;
                  <Button tiny icon="fa-pause" title={I18n.t("hold")} onClick={handleHold} />
                  &nbsp; &nbsp;
                  <Button
                    tiny
                    icon="fa-times"
                    title={I18n.t("un_hold")}
                    onClick={handleUnHold}
                  />
                </Fragment>
              ) : (
                <Fragment>
                  &nbsp; &nbsp;
                  <Button
                    tiny
                    title={I18n.t("toggle_hold_buttons")}
                    onClick={toggleHoldButtons}
                  />
                </Fragment>
              ))}
          </div>
          {showResultCaveatList && (
            <CaveatPicker type="result" ids={selectedSampleTestIds} onApply={reloadData} />
          )}
        </span>
      </th>
    </tr>
  );

  return (
    <div style={{ marginTop: 20 }}>
      <Table className="table table-condensed table-bordered table-hover form-inline">
        <thead>
          {!clientView && toolbarComponent()}
          <tr>
            <th colSpan={clientView ? 9 : 11}>
              {clientView && (
                <SampleActionBar
                  sampleIds={selectedSampleIds}
                  clientView={clientView}
                  showEditSamples={false}
                  reloadData={reloadData}
                />
              )}
              <label>
                <input
                  type="checkbox"
                  checked={!simpleSampleView}
                  onChange={toggleSimpleSampleView}
                />{" "}
                {I18n.t("view_sample_details")} &nbsp;&nbsp;|&nbsp;&nbsp;
              </label>
              {samples.length} {I18n.t("samples")} &nbsp;&nbsp;|&nbsp;&nbsp;
              {totalNumberOfTests} &nbsp;
              {I18n.t("results")}
              {!clientView && (
                <span>
                  &nbsp;&nbsp;|&nbsp;&nbsp;
                  {selectedTestCount} {I18n.t("selected_tests")}
                </span>
              )}
            </th>
            <th colSpan="8">{I18n.t("results")}</th>
          </tr>
          <tr>
            <th style={{ textAlign: "center" }}>
              <input type="checkbox" onChange={handleSelectSamples} />
            </th>
            {!simpleSampleView && (
              <Fragment>
                {!clientView && <th>{I18n.t("company")}</th>}
                <th>{I18n.t("sample")}</th>
                <th>{I18n.t("product")}</th>
                <th>{I18n.t("requested_test_date")}</th>
                <th>{I18n.t("registered")}</th>
                <th>{I18n.t("received")}</th>
                <th>{I18n.t("due_date")}</th>
              </Fragment>
            )}

            {simpleSampleView && <th>{I18n.t("sample")}</th>}

            <th>{I18n.t("technique")}</th>
            <th>{I18n.t("test_name")}</th>
            <th>{I18n.t("accred")}</th>
            <th>{I18n.t("result_lod")}</th>
            <th>
              {I18n.t("qualifier")}
              {addingResults && (
                <Fragment>
                  <br />
                  <Qualifier value={qualifier} onChange={setQualifier} />
                  <br />
                  <Link onClick={() => setAllQualifiers(qualifier)}>
                    {I18n.t("copy_to_all")}
                  </Link>
                </Fragment>
              )}
            </th>
            <th>{I18n.t("value")}</th>
            <th>{I18n.t("compound")}</th>
            <th>{I18n.t("status")}</th>
            <th>{I18n.t("limits")}</th>
            {!clientView && (
              <th>
                <input type="checkbox" checked={checked} onChange={handleChecked} />
              </th>
            )}
          </tr>
        </thead>
        <tbody>
          {samples.map((sample) => (
            <Sample
              clientView={clientView}
              key={sample.sample.identifier}
              sample={sample}
              selectedSampleTestIds={selectedTests.selected[sample.sample.identifier] || []}
              viewSingleSample={() => viewSingleSample(sample.sample.identifier)}
              simpleSampleView={simpleSampleView}
            />
          ))}
          {!clientView &&
            samples.length > 1 &&
            samples.reduce((total, sample) => total + sample.sample_tests.length, 0) > 100 &&
            toolbarComponent()}
        </tbody>
      </Table>
    </div>
  );
}
